import FaqPortal from "@Features/faq/components/FaqPortal";

function BusRentFaq() {
    return (<FaqPortal/>)
}

export default BusRentFaq
